export const EXPORT_TRANSACTION_HISTORY_REPORT_REQUEST = 'EXPORT_TRANSACTION_HISTORY_REPORT_REQUEST';
export const exportTransactionHistoryReportRequest = (walletId, params) => ({
  type: EXPORT_TRANSACTION_HISTORY_REPORT_REQUEST,
  walletId,
  params,
});
